// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TicketContainer_wrapper__3ZFJm","ticket":"TicketContainer_ticket__20CHw","loaded":"TicketContainer_loaded__2A1Jl"};